import { t } from '@lingui/core/macro';
import { MetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const documentCategoryFilterLabel = () => t({ message: 'Document category', comment: 'Insights filter: Document category' });
export function DocumentCategoryFilter() {
    return (<MetadataAllowedValuesFilter name="DocumentCategory" field="metadataDocumentDocumentCategory" label={documentCategoryFilterLabel()}/>);
}
